export default "__VITE_ASSET__LwwPDX7R__"